module.exports = __webpack_public_path__ + "img/ios2.d6a2b311.png";